/**
 * About
 * Masjid vision blurb plus the live daily prayer timetable sourced from the
 * usePrayerTimes hook. The Watch-Video CTA is disabled (TODO).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import tmr1 from '../../images/prayer-shape/2.png';
import tmr2 from '../../images/prayer-shape/1.png';
import tmr3 from '../../images/prayer-shape/3.png';
import usePrayerTimes from '../../hooks/usePrayerTimes';
import { MASJID } from '../../config/masjid';
import './style.css';

const About = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const { timings, gregorianDate, hijriDate, loading, error } =
    usePrayerTimes();
  return (
    <div className="wpo-about-area section-padding">
      <div className="container">
        <div className="wpo-about-wrap">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="wpo-about-img-3">
                {/* TODO: Add a meaningful alt description for the about section image */}
                <img
                  src={props.aboutImg}
                  alt="About Cole Harbour Islamic Society"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="wpo-about-text">
                <div className="wpo-section-title">
                  <span>Our Vision</span>
                  <h2>
                    A place of worship, learning, and community — coming to Cole
                    Harbour
                  </h2>
                </div>
                <p>
                  Cole Harbour is home to a growing Muslim community, yet we
                  still travel far for daily prayers, Jummah, and programs for
                  our children. This project will establish our
                  neighbourhood&apos;s first masjid — a welcoming space for the
                  five daily prayers, Quran and Islamic learning, youth and
                  family activities, and community gatherings. With your support
                  and du&apos;a, we can make it a reality, insha&apos;Allah.
                </p>
                <div className="btns">
                  <Link
                    onClick={ClickHandler}
                    to="/about"
                    className="theme-btn"
                    tabIndex="0"
                  >
                    Discover More
                  </Link>
                  {/* TODO: "Watch Our Video" is disabled until we have a real video.
                                        Restore <VideoModal/> from src/components/ModalVideo, set its
                                        videoId, and re-add the "Watch Our Video" label here. */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="timer-section">
          <div className="row">
            <div className="col-lg-5">
              <div className="timer-text">
                <h2>Prayer Times</h2>
                <p>
                  Prayer times in {MASJID.address.locality},{' '}
                  {MASJID.address.region}
                </p>
                {gregorianDate && <span>{gregorianDate}</span>}
                {hijriDate && <span className="hijri-date">{hijriDate}</span>}
              </div>
            </div>
            <div className="col-lg-5 offset-lg-1">
              <div className="timer-num">
                {loading && (
                  <p className="prayer-status">
                    Loading today&apos;s prayer times…
                  </p>
                )}
                {error && !loading && (
                  <p className="prayer-status prayer-error">
                    Prayer times are temporarily unavailable. Please try again
                    later.
                  </p>
                )}
                {!loading && !error && timings && (
                  <ul>
                    {timings.map((prayer) => (
                      <li key={prayer.name}>
                        <span className="prayer-name">{prayer.name}</span>
                        <span className="prayer-time-group">
                          <span className="prayer-time">
                            <small>Adhan</small>
                            {prayer.adhan}
                          </span>
                          {/* TODO: Restore Iqamah display once congregation times are confirmed. */}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
          <div className="timer-shape1">
            <img src={tmr1} alt="" />
          </div>
          <div className="timer-shape2">
            <img src={tmr2} alt="" />
          </div>
          <div className="timer-shape3">
            <img src={tmr3} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
